function informerModal() {
    if (!document.querySelector('.js-informer-modal')) return;

    document.addEventListener('click', (e) => {
        const target = e.target.closest('.js-informer-modal');

        if (!target) return;

        e.preventDefault();

        modals.openModal(null, '#product-card-credit', modal => {
            const title = modal.querySelector('.modal__title');
            const price = modal.querySelector('.js-product-card-credit-price');
            const credit = modal.querySelector('.js-product-card-credit-credit');

            title.textContent = target.dataset.title;
            price.textContent = formatAmount(target.dataset.price);
            credit.textContent = formatAmount(target.dataset.credit);
        })
    })
}
